import UserAvatar from 'app/shared-components/user/UserAvatar';
import ChannelLogo from 'app/shared-components/channel/ChannelLogo';

function ArticleAuthorAvatar({ article, mode, ...props }) {
  if (article?.userAuthor) {
    return <UserAvatar user={article.userAuthor} mode={mode} {...props} />;
  }
  
  if (article?.organizationAuthor) {
    return <ChannelLogo channel={article.organizationAuthor} mode={mode} {...props} />;
  }
  
  return null;
}

export default ArticleAuthorAvatar;